import React, { useEffect, useState } from "react";
import classNames from "classnames";
import { ArrowDownIcon } from "@/icons/primary/arrow-down-icon";
import { ArrowRightIcon } from "@/icons/primary/arrow-right-icon";

type Props = {
  label: string;
  icon?: React.ReactNode;
  active?: boolean;
  onClick?: (event: any) => void;
  href?: string;
  target?: "_blank" | "_self" | "_parent" | "_top";
  disabled?: boolean;
  children?: React.ReactNode | null;
  newStatus?: boolean;
  openedByDefault?: boolean;
};

export const SidebarOption: React.FC<Props> = ({
  label,
  icon,
  active,
  onClick,
  href,
  target = "_self",
  disabled,
  children = null,
  newStatus = false,
  openedByDefault = false,
}) => {
  const [open, setOpen] = useState(openedByDefault);
  const isLink = !!href;
  const Component = isLink ? "a" : "div";

  useEffect(() => {
    if (children) {
      const childrenArray = React.Children.toArray(children);
      const activeChildren = childrenArray.filter((child) => {
        return React.isValidElement(child) && child.props.active;
      });
      setOpen(activeChildren.length > 0 || openedByDefault);
    }
  }, [children]);

  const handleClick = (event: any) => {
    if (disabled) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (children) {
      event.preventDefault();
      setOpen(!open);
    }

    if (onClick) {
      onClick(event);
    }
  };

  return (
    <Component
      className={classNames("flex flex-col w-full px-2 relative")}
      href={href}
      target={target}
    >
      <div
        className={classNames(
          "flex items-center justify-between rounded-sm w-full font-sans-serif text-base px-6 py-3 hover:bg-light-neutral-3 cursor-pointer",
          active || open ? "bg-light-neutral-4" : "",
          disabled ? "opacity-50 cursor-not-allowed" : "",
        )}
        onClick={handleClick}
      >
        <div className={classNames("flex gap-3 items-center justify-start")}>
          {icon && <div className={classNames("text-2xl flex items-center")}>{icon}</div>}
          <label
            className={classNames(
              "font-base font-sans-serif text-dark-neutral-1 font-weight-normal cursor-pointer",
            )}
          >
            {label}
          </label>
        </div>
        {children && (
          <div className={classNames("flex items-center justify-center text-mid-neutral-1")}>
            {open ? (
              <ArrowDownIcon className='text-2xl' />
            ) : (
              <ArrowRightIcon className='text-2xl' />
            )}
          </div>
        )}
      </div>
      {children && open && (
        <div className={classNames("flex flex-col gap-3 pl-12 pr-4 pt-3")}>{children}</div>
      )}
      {newStatus && (
        <div
          className={classNames(
            "absolute -top-2 right-10 py-1 px-1.5 flex items-center justify-center text-xs font-sans-serif font-semibold text-white bg-danger rounded-full mr-2",
          )}
        >
          NEW
        </div>
      )}
    </Component>
  );
};
